<template>
  <div>
    <div class="text-center border border-bottom-0 border-gray-500">
      <div
          v-for="({item:{name, title}, isActive}) in tabs"
          class="d-inline-block w-50 cursor-pointer"
          v-bind:class="{'bg-white': isActive, 'bg-gray-500': !isActive}"
          @click="onSelect(name)"
      >
        <div class="pt-2 pb-2">
          <h6 class="mb-0" v-text="title"></h6>
        </div>
      </div>
    </div>
    <div class="border border-top-0 border-gray-500 p-2">
      <div>
        <chat-component
            v-if="active === 'chat'"
            :conversation="conversation"
            style="height: 550px"
            class="d-flex flex-column"
            :index-media-url="indexMediaUrl"
            :can-create-media="canCreateMedia"
            :store-media-url="storeMediaUrl"
            :can-send-message="canSendMessage"
            :types="types"
        ></chat-component>
      </div>
      <send-list-manager
          v-if="active === 'groups'"
          :url="url"
          @change="onSendListsChange"
      ></send-list-manager>
    </div>
  </div>
</template>

<script>
import ChatComponent from './chat';
import SendListManager from '../../../../components/shared/send-list-conversation/quick-add/table';

export default {
  components: {
    ChatComponent,
    SendListManager,
  },

  props: {
    conversation: Object,
    indexMediaUrl: String,
    canCreateMedia: {
      type: Boolean,
      default: false,
    },
    storeMediaUrl: String,
    canSendMessage: {
      type: Boolean,
      default: false,
    },
    types: Object,
  },

  data() {
    return {
      items: [
        {name: 'chat', title: 'CHAT'},
        {name: 'groups', title: 'GROUPS'},
      ],
      active: 'chat',
    };
  },

  computed: {
    /**
     * @return {Array}
     */
    tabs() {
      return _.chain(this.items)
          .map(item => ({
            item,
            isActive: item.name === this.active,
          }))
          .keyBy(item => item.item.name)
          .value();
    },

    /**
     * @return {string|null}
     */
    url() {
      return _.get(this.conversation, 'sendListQuickIndexUrl', null);
    },
  },

  methods: {
    /**
     * @param {string} name
     */
    onSelect(name) {
      this.active = name;
    },

    /**
     * @param payload
     * @emits change
     */
    onSendListsChange(payload) {
      this.$emit('change', payload);
    },
  },
}
</script>
